export default [
  { label: 'Architect (INTJ-A)', value: 'INTJ-A' },
  { label: 'Architect (INTJ-T)', value: 'INTJ-T' },
  { label: 'Logician (INTP-A)', value: 'INTP-A' },
  { label: 'Logician (INTP-T)', value: 'INTP-T' },
  { label: 'Commander (ENTJ-A)', value: 'ENTJ-A' },
  { label: 'Commander (ENTJ-T)', value: 'ENTJ-T' },
  { label: 'Debater (ENTP-A)', value: 'ENTP-A' },
  { label: 'Debater (ENTP-T)', value: 'ENTP-T' },
  { label: 'Advocate (INFJ-A)', value: 'INFJ-A' },
  { label: 'Advocate (INFJ-T)', value: 'INFJ-T' },
  { label: 'Mediator (INFP-A)', value: 'INFP-A' },
  { label: 'Mediator (INFP-T)', value: 'INFP-T' },
  { label: 'Protagonist (ENFJ-A)', value: 'ENFJ-A' },
  { label: 'Protagonist (ENFJ-T)', value: 'ENFJ-T' },
  { label: 'Campaigner (ENFP-A)', value: 'ENFP-A' },
  { label: 'Campaigner (ENFP-T)', value: 'ENFP-T' },
  { label: 'Logistician (ISTJ-A)', value: 'ISTJ-A' },
  { label: 'Logistician (ISTJ-T)', value: 'ISTJ-T' },
  { label: 'Defender (ISFJ-A)', value: 'ISFJ-A' },
  { label: 'Defender (ISFJ-T)', value: 'ISFJ-T' },
  { label: 'Executive (ESTJ-A)', value: 'ESTJ-A' },
  { label: 'Executive (ESTJ-T)', value: 'ESTJ-T' },
  { label: 'Consul (ESFJ-A)', value: 'ESFJ-A' },
  { label: 'Consul (ESFJ-T)', value: 'ESFJ-T' },
  { label: 'Virtuoso (ISTP-A)', value: 'ISTP-A' },
  { label: 'Virtuoso (ISTP-T)', value: 'ISTP-T' },
  { label: 'Adventurer (ISFP-A)', value: 'ISFP-A' },
  { label: 'Adventurer (ISFP-T)', value: 'ISFP-T' },
  { label: 'Entrepreneur (ESTP-A)', value: 'ESTP-A' },
  { label: 'Entrepreneur (ESTP-T)', value: 'ESTP-T' },
  { label: 'Entertainer (ESFP-A)', value: 'ESFP-A' },
  { label: 'Entertainer (ESFP-T)', value: 'ESFP-T' },
]
